import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'semantic-ui-react';

const FieldStatusIcon = (props) => {
    let icon = <Icon name=''/>;

    if (props.show) {
        if (props.error) {
            icon = <Icon className={'field-status-icon error-text-color'} name={'remove circle'}/>;
        } else if (props.isSaving) {
            icon = <Icon className={'field-status-icon'} loading name={'spinner'}/>;
        } else if (props.saved) {
            icon = <Icon className={'field-status-icon correct-text-color saved-input-fade-out'} name={'check circle'}/>;
        }
    }

    return icon;
};

FieldStatusIcon.propTypes = {
    show: PropTypes.bool,
    error: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
    saved: PropTypes.bool.isRequired
};

FieldStatusIcon.defaultProps = {
    show: true
};

export default FieldStatusIcon;



// WEBPACK FOOTER //
// ./public/components/forms/FieldStatusIcon.jsx